<template>
  <div
    class="months-wrapper noselect"
    @touchstart="touchStarted"
    @mousedown="touchStartedMouse"
    @touchend="touchEnded"
    @mouseup="touchEndedMouse"
  >
    <month
      v-for="n in 12"
      :key="n"
      :current-month="n"
      :current-year="currentYear"
    />
  </div>
</template>

<script>
import MonthVue from "./Month.vue";
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  data() {
    return {
      xStart: 0
    };
  },
  computed: {
    ...mapGetters({
      selectedProviderID: "getSelectedProviderID"
    }),
    currentYear() {
      if (isNaN(this.$route.params.year)) {
        return 2019;
      } else {
        return parseInt(this.$route.params.year);
      }
    }
  },
  props: {
    increaseYear: Function,
    decreaseYear: Function
  },
  methods: {
    ...mapActions({
      getYearlyAppointments: "getYearlyAppointments"
    }),
    ...mapMutations({
      setYear: "setYear"
    }),
    touchStarted(event) {
      this.xStart = event.changedTouches[0].screenX;
    },
    touchEnded(event) {
      const diff = event.changedTouches[0].screenX - this.xStart;
      if (Math.abs(diff) > 50 && diff > 0) {
        // Go to previous year
        this.decreaseYear();
      } else if (Math.abs(diff) > 50 && diff < 0) {
        // Go to next year
        this.increaseYear();
      }
    },
    touchStartedMouse(event) {
      this.xStart = event.screenX;
    },
    touchEndedMouse(event) {
      const diff = event.screenX - this.xStart;
      if (Math.abs(diff) > 50 && diff > 0) {
        // Go to previous year
        this.decreaseYear();
      } else if (Math.abs(diff) > 50 && diff < 0) {
        // Go to next year
        this.increaseYear();
      }
    }
  },
  components: {
    month: MonthVue
  },
  created() {
    this.setYear(this.currentYear);
    this.getYearlyAppointments(this.currentYear);
  },
  watch: {
    selectedProviderID() {
      this.getYearlyAppointments(this.currentYear);
    }
  }
};
</script>
